import { validationMessages } from './validationMessages.schema';

export default {
  type: 'object',
  properties: {
    statusId: {
      title: 'Status',
      type: 'number',
      fieldRequired: true
    },
    comment: {
      title: 'Komentarz',
      type: 'string',
      fieldRequired: false
    }
  },
  allOf: [validationMessages]
};
